import { Component, Input } from '@angular/core';
import { BaseItemModelService } from '../../template/base-item.model';
import {
    FI_DOCUMENT_TEMPLATE_ITEM_VIEW_DATA,
    IFiDocumentTemplateItemViewData,
} from './document-template-item-view-base';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';

@Component({
    selector: 'fi-document-template-item-view',
    template: '<ng-container *ngComponentOutlet="item.viewComponent"></ng-container>',
    providers: [
        {
            provide: FI_DOCUMENT_TEMPLATE_ITEM_VIEW_DATA,
            useFactory: (
                documentTemplateItemViewComponent: FiDocumentTemplateItemViewComponent,
            ): IFiDocumentTemplateItemViewData => ({
                item: documentTemplateItemViewComponent.item,
                disableEdit: documentTemplateItemViewComponent.disableEdit,
                templateLayoutHelper: documentTemplateItemViewComponent.templateLayoutHelper,
            }),
            deps: [FiDocumentTemplateItemViewComponent],
        },
    ],
    standalone: false,
})
export class FiDocumentTemplateItemViewComponent {
    @Input() item: BaseItemModelService;
    @Input() disableEdit: boolean;
    @Input() templateLayoutHelper: TemplateLayoutHelper;
}
